if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.menuDrawer = document.querySelector('.menu-drawer');

        this.elements = {
          form: this.querySelector('form'),
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };

        if (!this.elements.form || !this.elements.input || !this.elements.button || !this.elements.panel) {
          return;
        }

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));

        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }

        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }

        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', function (event) {
            event.preventDefault();
          });
        }

        this.querySelectorAll('a[data-value]').forEach((item) => {
          item.addEventListener('click', this.onItemClick.bind(this));
        });
      }

      hidePanel() {
        if (this.elements.button) {
          this.elements.button.setAttribute('aria-expanded', 'false');
        }

        if (this.elements.panel) {
          this.elements.panel.setAttribute('hidden', true);
        }

        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }

        document.body.classList.remove('overflow-hidden-mobile');

        if (this.menuDrawer) {
          this.menuDrawer.classList.remove('country-selector-open');
        }

        if (this.header) {
          this.header.preventHide = false;
        }
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a[data-value]')).filter(function (item) {
          return !item.parentElement.classList.contains('hidden');
        });

        if (!focusableItems.length) return;

        let focusedItemIndex = focusableItems.findIndex(function (item) {
          return item === document.activeElement;
        });

        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0
                ? focusableItems[focusedItemIndex - 1]
                : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;

          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1
                ? focusableItems[focusedItemIndex + 1]
                : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex(function (item) {
            return item === document.activeElement;
          });

          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (!this.elements.button || this.elements.button.getAttribute('aria-expanded') === 'false') return;

            event.preventDefault();
            event.stopPropagation();

            this.hidePanel();
            this.elements.button.focus();
            break;

          case 'SPACE':
            if (!this.elements.button || this.elements.button.getAttribute('aria-expanded') === 'true') return;

            event.preventDefault();
            this.openSelector(event);
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();

        const selectedValue = event.currentTarget.dataset.value;

        if (!selectedValue || !this.elements.input || !this.elements.form) return;

        this.elements.input.value = selectedValue;

        if (typeof this.elements.form.requestSubmit === 'function') {
          this.elements.form.requestSubmit();
        } else {
          this.elements.form.submit();
        }
      }

      openSelector(event) {
        if (event) {
          event.preventDefault();
        }

        if (!this.elements.button || !this.elements.panel) return;

        this.elements.button.focus();

        const isOpen = this.elements.button.getAttribute('aria-expanded') === 'true';

        this.elements.panel.toggleAttribute('hidden', isOpen);
        this.elements.button.setAttribute('aria-expanded', (!isOpen).toString());

        if (!isOpen) {
          if (!document.body.classList.contains('overflow-hidden-tablet')) {
            document.body.classList.add('overflow-hidden-mobile');
          }

          if (this.elements.search && this.mql.matches) {
            this.elements.search.focus();
          }

          if (this.hasAttribute('data-prevent-hide') && this.header) {
            this.header.preventHide = true;
          }

          if (this.menuDrawer) {
            this.menuDrawer.classList.add('country-selector-open');
          }
        } else {
          document.body.classList.remove('overflow-hidden-mobile');

          if (this.menuDrawer) {
            this.menuDrawer.classList.remove('country-selector-open');
          }

          if (this.header) {
            this.header.preventHide = false;
          }
        }
      }

      closeSelector(event) {
        if (!event) return;

        const clickedOverlay = event.target.classList && event.target.classList.contains('country-selector__overlay');
        const focusLeftComponent = !this.contains(event.target) || !this.contains(event.relatedTarget);

        if (clickedOverlay || focusLeftComponent) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        if (!this.elements.search) return;

        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a[data-value]');
        let visibleCountries = 0;

        if (this.elements.resetButton) {
          this.elements.resetButton.classList.toggle('hidden', !searchValue);
        }

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', Boolean(searchValue));
        }

        allCountries.forEach((item) => {
          const countryElement = item.querySelector('.country');
          const labelText = countryElement ? countryElement.textContent : item.textContent;
          const countryName = this.normalizeString(labelText);

          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
          }
        });

        if (this.elements.liveRegion && window.accessibilityStrings && window.accessibilityStrings.countrySelectorSearchCount) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        const countrySelector = this.querySelector('.country-selector');
        const countrySelectorList = this.querySelector('.country-selector__list');

        if (countrySelector) {
          countrySelector.scrollTop = 0;
        }

        if (countrySelectorList) {
          countrySelectorList.scrollTop = 0;
        }
      }

      resetFilter(event) {
        if (event) {
          event.stopPropagation();
        }

        if (!this.elements.search) return;

        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        if (this.elements.searchIcon) {
          this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
        }
      }

      onSearchBlur() {
        if (!this.elements.search || !this.elements.searchIcon) return;

        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}